import {
  READY_CHANGE_TIME_REPORT,
  RESET_TIME_REPORT
} from '../actions/reportTimeActions'

import { states } from './queriesStates'
import getDates from './../shared/services/date.service'

const getNextDate = () => {
  const date = new Date();

  return new Date(date.setDate(date.getDate() + 1));
};

const initialState = {
  dataState: states.NOT_REQUESTED,
  reportRangeTime: {
    reportStartDate: getDates.getNullTimeDate(new Date()),
    reportEndDate: getDates.getNullTimeDate(getNextDate()),
    reportStartTime: getDates.getNullTimeDate(new Date()),
    reportEndTime: getDates.getNullTimeDate(new Date())
  },
}

const reportTimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_TIME_REPORT: {
      const { name, value } = action.payload
      var reportRangeTime = Object.assign({}, state.reportRangeTime)

      typeof (name) === 'object'
        ? name.map((item, index) => {
          reportRangeTime[item] = value[index]
          return null;
        })
        : reportRangeTime[name] = value

      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          reportRangeTime: reportRangeTime
        }
      )
    }
    case RESET_TIME_REPORT:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default reportTimeReducer
